export const setSelectedUser = function(state, user) {
  state.selectedUser = user
}

export const setSelectedGroup = function(state, group) {
  state.selectedGroup = group
}
